import React from "react";
import { Box, Button, useTheme } from "@mui/material";
import { SignInButton, SignUpButton } from "@clerk/clerk-react";

export default function AuthButtons({ compact = false }) {
    const theme = useTheme();
    const secondary = theme.palette.secondary.main;
    const secondaryDark = theme.palette.mode === "dark" ? "#3da58a" : secondary;
  
    const common = {
      textTransform: "uppercase",
      fontWeight: 700,
      letterSpacing: "0.4px",
      borderRadius: 1,
      boxShadow: "none",
      minWidth: compact ? 0 : 100,
      px: compact ? 1.5 : 2.5,
      py: compact ? 0.5 : 1,
      fontSize: compact ? 12 : 14,
    };
  
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: compact ? 1 : 1.5, p: compact ? 0 : 1, px: compact ? 0 : 2 }}>
        <SignInButton mode="modal">
          <Button variant="contained" color="secondary" sx={{ ...common, "&:hover": { backgroundColor: secondaryDark, boxShadow: "none" } }}>
            Sign In
          </Button>
        </SignInButton>
        <SignUpButton mode="modal">
          <Button
            variant="outlined"
            sx={{
              ...common,
              color: secondary,
              borderColor: secondary,
              "&:hover": {
                borderColor: secondaryDark,
                backgroundColor: "rgba(76,206,172,0.08)",
              },
            }}
          >
            Sign Up
          </Button>
        </SignUpButton>
      </Box>
    );
  }